import React from 'react';
import { Truck, ShieldCheck, Sparkles, Award } from 'lucide-react';

const items = [
  { icon: Truck, title: 'Free Shipping', sub: 'Above ₹599' },
  { icon: ShieldCheck, title: '100% Genuine', sub: 'Long-lasting' },
  { icon: Award, title: 'Award Winning', sub: '4.8 · 2000+' },
  { icon: Sparkles, title: 'Free Sample', sub: 'Above ₹2,499' }
];

export default function UspStrip() {
  return (
    <div className="border-y border-[#E5DCC9] bg-[#EFE6D6]/60">
      {/* Mobile: horizontal snap scroll */}
      <div className="md:hidden flex gap-3 overflow-x-auto no-scrollbar snap-x snap-mandatory px-3 py-3.5">
        {items.map(({ icon: Icon, title, sub }) => (
          <div
            key={title}
            className="snap-start flex-shrink-0 w-[42vw] max-w-[11rem] flex items-center gap-2.5 bg-[#F5EFE6]/70 border border-[#E5DCC9] rounded-md px-3 py-2.5"
          >
            <div className="w-8 h-8 rounded-full border border-[#C9A961] flex items-center justify-center flex-shrink-0">
              <Icon className="w-3.5 h-3.5 text-[#8a6f2d]" strokeWidth={1.5} />
            </div>
            <div className="min-w-0">
              <p className="text-[11px] font-semibold text-[#1A2332] tracking-wide truncate">{title}</p>
              <p className="text-[10px] text-[#1A2332]/60 truncate">{sub}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop / tablet grid */}
      <div className="hidden md:grid max-w-7xl mx-auto px-4 md:px-6 py-5 grid-cols-4 gap-6">
        {items.map(({ icon: Icon, title, sub }) => (
          <div key={title} className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full border border-[#C9A961] flex items-center justify-center flex-shrink-0">
              <Icon className="w-4 h-4 text-[#8a6f2d]" strokeWidth={1.5} />
            </div>
            <div>
              <p className="text-[13px] font-semibold text-[#1A2332] tracking-wide">{title}</p>
              <p className="text-[11px] text-[#1A2332]/60">{sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
